import React from 'react';
import { connect } from 'react-redux';
import ResultsCardPres from '../presentational/ResultsCardPres';
import CurrencyFormat from 'react-currency-format';
import intl from 'react-intl-universal';

class ResultsCardContainer extends React.Component {
  state = {
    barSeriesConfig: {
      baseCompensation: {
        color: this.props.colors[0],
      },
      relocationCosts: {
        color: this.props.colors[1],
      },
      assignmentAllowances: {
        color: this.props.colors[2],
      },
      taxes: {
        color: this.props.colors[3],
      },
    },
    barSeriesData: [
      {
        name: this.props.result.homeCountry + ' to ' + this.props.result.hostCountry,
        Taxes: Math.abs(this.props.result.taxes.total * this.props.result.numEmployees),
        'Assignment Allowances': this.props.result.assignmentAllowances.total * this.props.result.numEmployees,
        'Relocation Costs': this.props.result.relocationCosts.total * this.props.result.numEmployees,
        'Base Compensation': this.props.result.baseCompensation.total * this.props.result.numEmployees,
      },
    ],
    hoveredSeries: null,
  };

  componentDidMount() {
    this.setState({
      cardHeader: this.getCardHeader(),
      cardFooter: this.getCardFooter(),
    });
  }

  getCardHeader() {
    const { classification, numEmployees } = this.props.result;
    return <span>{(numEmployees > 1 ? numEmployees + ' x ' : '') + classification}</span>;
  }

  getCardFooter() {
    const { totalCompensation, numEmployees, outputCurrency } = this.props.result;

    return (
      <CurrencyFormat
        value={totalCompensation}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={true}
        prefix={intl.get('whatif.calculator.currency.prefix')[outputCurrency]}
        suffix={intl.get('whatif.calculator.currency.suffix')[outputCurrency]}
        renderText={value => <div>{numEmployees > 1 ? numEmployees + ' x ' + value : value}</div>}
      />
    );
  }

  onCheck = () => {
    this.props.handleResultSelect(this.props.index);
  };

  onUncheck = () => {
    this.props.handleResultSelect(this.props.index);
  };

  onCancel = () => {
    this.props.handleResultCancel(this.props.index);
  };

  onClick = () => {
    this.props.handleResultClick(this.props.index);
  };

  onMouseLeave = value => {
    let barSeries = this.state.barSeries;
    barSeries[value.id].opacity = 0.8;

    this.setState({
      barSeries: barSeries,
      hoveredSeries: null,
    });
  };

  onMouseOver = value => {
    let barSeries = this.state.barSeries;
    barSeries[value.id].opacity = 1;

    this.setState({
      barSeries: barSeries,
      hoveredSeries: barSeries[value.id],
    });
  };

  render() {
    return (
      <ResultsCardPres
        {...this.props}
        {...this.state}
        onCheck={this.onCheck.bind(this)}
        onUncheck={this.onUncheck.bind(this)}
        onCancel={this.onCancel.bind(this)}
        onClick={this.onClick.bind(this)}
        onMouseOver={this.onMouseOver.bind(this)}
        onMouseLeave={this.onMouseLeave.bind(this)}
      />
    );
  }
}

const mapStateToProps = state => ({
  colors: state.whatIf.colors,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsCardContainer);
